// extracted by mini-css-extract-plugin
module.exports = {"tile":"Game_tile__1orK8","gameTiles":"Game_gameTiles__33VjA"};